/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { containers } from '@telus/redux-contentful'
import CustomerSelectAccount from './components/pages/CustomerSelectAccount'
import PartnerPortalHome from './components/pages/PartnerPortalHome'
import Custom404 from './components/pages/Custom404'

const { withPage } = containers

export const routes = (
  client = null,
  locale = { lang: ' en' }
) => {
  return (
    [
      {
        path: '/profile',
        secure: true,
        component: withPage({
          client,
          slug:  'account-select',
          contentType: 'customerAccountSelect',
          locale: `${locale.lang}-CA`
        })(CustomerSelectAccount)
      },
      {
        path: '/404',
        secure: false,
        component: withPage({
          client,
          slug:  '404',
          contentType: 'custom404page',
          locale: `${locale.lang}-CA`
        })(Custom404)
      },
      {
        path: '/portal',
        secure: true,
        component: withPage({
          client,
          slug:  'portal',
          contentType: 'authenticatedLandingPage',
          locale: `${locale.lang}-CA`
        })(PartnerPortalHome)
      }
    ]
  )
}
const getUIRoutes = (
  client = null,
  locale = { lang: ' en' }
) => {
  const contentfulRoute = routes(
    client,
    locale
  )

  return (
    <Switch>
      {[
        contentfulRoute.map(({ path, component: Comp }) => (
          <Route key={path} path={path} exact render={props => <Comp {...props} />} />
        ))
      ]}
    </Switch>
  )
}

export default getUIRoutes
